// extracted by css-extract-rspack-plugin
export default {"actionsCell":"CampaignsTableRow_actionsCell__UeOyY"};